import Vue from 'vue';
import VueRouter, { NavigationGuard, RouterOptions } from 'vue-router';
import Home from '../views/home/Home.vue';
import { Controlador as Autenticacion } from '@view/a-login/login-controlador';
import { Socket } from './main';

Vue.use( VueRouter );

import '@com/inputs';
import '@com/selectores';
import '@com/shared';
import '@com/dialogs';


const ifNotAuthenticated: NavigationGuard = async ( to, from, next ) =>
{

    await Autenticacion.Iniciar();
    if ( !await Autenticacion.Validar() )
    {
        next();
    }
    else
    {
        next( '/' );
    }

};


const ifAuthenticated: NavigationGuard = async ( to, from, next ) =>
{


    await Autenticacion.Iniciar();
    if ( await Autenticacion.Validar() )
    {
        if ( !Socket.connected )
            await Socket.connect();
        next();
    }
    else
    {
        Autenticacion.Redireccionar = to.fullPath;
        next( '/login');
    }
};

const routes: RouterOptions = {
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/', component: () => import( '@env/shared/template/SinMenu.vue' ),
            children: [


                { path: '/login', component: () => import( '@view/a-login/login.vue' ), beforeEnter: ifNotAuthenticated },
                { path: '/login/:id', component: () => import( '@view/a-login/login.vue' ), beforeEnter: ifNotAuthenticated },
                { path: '/recuperar/:id', component: () => import( '@view/a-login/login.vue' ), beforeEnter: ifNotAuthenticated },

                { path: '/', component: () => import( '@view/curso-tomar/curso.vue' ), beforeEnter: ifAuthenticated },
                { path: '/c', component: () => import( '@view/curso-tomar/curso.vue' ), beforeEnter: ifAuthenticated },
                { path: '/c/:id', component: () => import( '@view/curso-tomar/curso.vue' ), beforeEnter: ifAuthenticated },

            ]
        },
        //{ path: '/login', component: () => import( '@env/shared/login/login-ingreso.vue' ), beforeEnter: ifNotAuthenticated },
        //{ path: '/nuevo', component: () => import( '@env/shared/login/login-nuevo.vue' ), beforeEnter: ifNotAuthenticated },
        //{ path: '/recuperar', component: () => import( '@env/shared/login/login-recuperar.vue' ), beforeEnter: ifNotAuthenticated },
        //{ path: '/recuperar/:id?', component: () => import( '@env/shared/login/login-recuperar.vue' ), beforeEnter: ifNotAuthenticated },
    ]
};


const router = new VueRouter( routes );

export default router;
